BaseCollection = require('base/collection')
Model = require('./report-model')

class ReportAdWordsCollection extends BaseCollection
  url: -> 'adwords/report'

  model: Model

module.exports = ReportAdWordsCollection